module.exports = __webpack_public_path__ + "img/bls-1.2d9c768b.png";